import Api from '../../../../Api';

export const UserImportService = {
  import: async (externalIds: string[]): Promise<Boolean> => {
    const response = await Api.post('support/userimport/import', externalIds);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  },
};
